import axios from 'axios'
import { getConfigSection } from '../config'

const config = getConfigSection('api')

// Create axios instance with base URL from config
const api = axios.create({
    baseURL: config.base
})

// Add request interceptor to attach token to every request
api.interceptors.request.use(
    reqConfig => {
        const token = sessionStorage.getItem('ARO_ADMIN_SID')
        
        if (token) {
            reqConfig.headers.Authorization = 'Bearer ' + token
        }
        
        return reqConfig
    },
    error => {
        return Promise.reject(error)
    }
)

export default api
